<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A6papn/tc-custom/9781952225819.jpg?1694739750665" alt="This image is the cover for the book 16 Minutes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">16 Minutes
      </h1>
      <p class="bookDescription body article font2">
        <b>A grizzly arson case leads an Indianapolis prosecutor to an infant’s coldblooded killer in this chilling true crime by the author of <i>Inconvenience Gone</i>.</b><br/>  <br/> On the morning of March 6, 1993, an intense fire broke out in a tiny nursery. Sixteen minutes later, firefighters had extinguished the blaze. The room was burned so severely, that virtually nothing was recognizable . . . but they were told to look for a baby. What they discovered was almost too gruesome for words. Not only the baby’s charred remains, but an unsettling fact: the child’s parents were home at the time the fire broke out.<br/>  <br/> The arson squad declared the fire suspicious and investigators determined it was arson. But if it truly was arson, what was the motive? Along with the tenacious and determined Detective Leslie Van Buskirk, Marion County Prosecutor Diane Marger Moore persisted for more than two years to get justice for Baby Matthew Wise. In <i>16 Minutes</i>, she recounts the incredible story—and the shocking revelations she made.&lt;/
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Marger Moore
      </h2>
      
      <p class="authorDescription body article">Diane Marger Moore had been a criminal defense lawyer for more than a decade when she met and married her husband, an Indianapolis native. After moving to Indiana, she was hired to serve as the chief arson prosecutor for Marion County.  Only months into the job, and with little to no experience as a prosecutor, she had to decide whether to try or dismiss an arson case involving the death of an eight-week-old child. As the mother of two young children, and with politics on all sides, including pressure from the assigned homicide detective, she had to decide the best path to obtain justice for the infant, Baby Matthew Wise.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5db8cf5c